import { IdeaListResponse } from '../../model/IdeaListResponse'
import { ideasbankApiClient as ideasAPI } from '../index'

const isOpenSearchEnabled = () => process.env.REACT_APP_IDEASBANK_ENABLE_OPENSEARCH === 'true'

export const fetchHighlightedIdeas = (data: any) => {
  if (isOpenSearchEnabled()) {
    return ideasAPI.get<{ data: IdeaListResponse }>('/ideas/opensearch', {
      params: {
        ...data,
        highlight: true,
        semanticSearch: true,
        sortBy: 'recent-first',
        draft: false,
      },
    })
  }

  return ideasAPI.get<{ data: IdeaListResponse }>('/ideas/list/fulltext', {
    params: {
      ...data,
      highlight: true,
      sortBy: 'recent-first',
      draft: false,
    },
  })
}
